import type { ExtendsOfElementBase } from "@/canvasController/types";
import { Group } from "@/group";

export function lockElementAndDescendants(element: Group | ExtendsOfElementBase, mode: boolean) {
    if (element instanceof Group) {
        element.fixState("lock");
        element.isLocked = mode;
        element.saveState();

        if (element.children && element.children.length > 0) {
            if (Array.isArray(element.children)) {
                element.children.forEach((child) => {
                    lockElementAndDescendants(
                        child as unknown as Group | ExtendsOfElementBase,
                        mode,
                    );
                });
            }
        }
    }
}
